import { Svg } from '../../../../..'

export interface HomeIconProps {
  dataQa: string
}

export const HomeIcon = ({ dataQa }: HomeIconProps) => (
  <Svg data-qa={dataQa} width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.55279 1.21065C6.8348 0.929783 7.29186 0.929783 7.57387 1.21065L12.5739 6.21065C12.855 6.49152 12.855 6.94859 12.5739 7.22946C12.293 7.51032 11.8359 7.51032 11.5551 7.22946L11.0633 6.73766V11.5C11.0633 12.3284 10.3917 13 9.56332 13H4.56332C3.73489 13 3.06332 12.3284 3.06332 11.5V6.73766L2.57152 7.22946C2.29065 7.51032 1.83359 7.51032 1.55272 7.22946C1.27185 6.94859 1.27185 6.49152 1.55272 6.21065L6.55279 1.21065ZM4.06332 5.73766V11.5C4.06332 11.7761 4.28718 12 4.56332 12H6.06332V9C6.06332 8.44771 6.51104 8 7.06332 8C7.61561 8 8.06332 8.44771 8.06332 9V12H9.56332C9.83946 12 10.0633 11.7761 10.0633 11.5V5.73766L7.06332 2.73766L4.06332 5.73766Z'
      fill='#9D9298'
    />
  </Svg>
)
